import { render } from "./TOP.vue?vue&type=template&id=ac7ca870&scoped=true"
import script from "./TOP.vue?vue&type=script&lang=js"
export * from "./TOP.vue?vue&type=script&lang=js"

import "./TOP.vue?vue&type=style&index=0&id=ac7ca870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7ca870"]])

export default __exports__